import L from "lodash/fp";
import inject from "scripts/ioc/inject";
import BaseView from "scripts/views/baseView";
import { addLinksToText } from "scripts/utils/viewHelpers";

const getDoiLink = doi =>
  doi ? (/^https?/.test(doi) ? doi : `https://doi.org/${doi}`) : null;

class BaseContentDetailsDetailsSubPageView extends BaseView {
  constructor(
      options,
      securityService = inject("securityService"),
  ) {
    super(options);

    this.securityService = securityService;
  }


  render() {
    const authScope = this.securityService.getAuthScopeFromSubdomain();

    const attrs = L.merge(this.model.toJSON(), {
      attribution: addLinksToText(this.model.get("attribution")),
      doi: addLinksToText(getDoiLink(this.model.get("doi"))),
      isTorl: authScope === 'openresearchlibrary',
    });

    this.$el.html(this.template(attrs));

    return this;
  }

  sync() {
    return this.model.fetch();
  }
}

export default BaseContentDetailsDetailsSubPageView;
